import 'client/javascript/main';
import Overlay from 'client/javascript/overlay';
import { onContentLoaded } from 'client/javascript/on_content_loaded';
import { onPolyfillsLoaded } from 'client/javascript/util/polyfills';
import { setupQuoteForm } from 'client/javascript/pages/hq_by_we/setup_quote_form';
import { showElements, hideElements } from 'client/javascript/util/dom_utils';

const FIXED_QUOTE_CLASS = 'hq-by-we__quote--fixed';
const STEP_1_ID = 'quote-form-step-1';
const STEP_2_ID = 'quote-form-step-2';

function quoteContainerObserverCallback(entries) {
  const entry = entries[0];
  const quoteContainerElement = entry.target;
  const quoteElement = document.getElementById('hq-by-we-quote');

  // If the quoteElement has the fixed quote class, it means that the quote container is not visible. Therefore,
  // even if the intersection ratio is 0, if the quoteElement has this class, the quote container is coming back
  // into view.
  const quoteContainerIsVisible = entry.intersectionRatio > 0 || quoteElement.classList.contains(FIXED_QUOTE_CLASS);

  if (quoteContainerIsVisible) {
    quoteElement.classList.remove(FIXED_QUOTE_CLASS);
    quoteContainerElement.style.height = 'auto';
    quoteContainerElement.style.marginBottom = '0px';
  } else {
    const style = getComputedStyle(quoteElement);

    quoteContainerElement.style.height = style.height;
    quoteContainerElement.style.marginBottom = style.marginBottom;

    quoteElement.classList.add(FIXED_QUOTE_CLASS);
  }
}

function showStep1() {
  const step1 = document.getElementById(STEP_1_ID);
  const step2 = document.getElementById(STEP_2_ID);

  showElements(step1);
  hideElements(step2);
}

function showStep2() {
  const step1 = document.getElementById(STEP_1_ID);
  const step2 = document.getElementById(STEP_2_ID);

  hideElements(step1);
  showElements(step2);
}

function observeQuoteContainer() {
  const observer = new IntersectionObserver(quoteContainerObserverCallback);
  const quoteContainerElement = document.getElementById('hq-by-we-quote-container');

  observer.observe(quoteContainerElement);
}

function setupQuoteOverlay() {
  const overlay = new Overlay('quote-overlay', {
    excludeCloseButton: true,
    focusTrap: { initialFocus: '#full_name' }
  });

  const closeButton = document.getElementById('quote-form-close-btn');
  closeButton.addEventListener('click', overlay.close);

  const quoteOverlayContent = document.getElementById('quote-overlay-content');
  overlay.addContent(quoteOverlayContent);

  const quoteButton = document.getElementById('quote-button');

  quoteButton.addEventListener('click', evt => {
    overlay.open(evt, () => {
      showStep1();
      showElements(quoteOverlayContent);
    });
  });
}

onContentLoaded(() => {
  onPolyfillsLoaded(() => {
    observeQuoteContainer();
    setupQuoteForm(showStep2);
    setupQuoteOverlay();
  });
});
